
/*
 * ide buchstaben limits pro kompressor sind nur geraten, sollten hoffentlich passen.
 */
const limits = [
	{
		count: 4,
		limit: 10
	},
	{
		count: 8,
		limit: 7
	},
	{
		count: 10,
		limit: 4
	}
];

export const getComponentNameShort = (cindex, compressors, intl) => {
	// die station!
	if (cindex < 0) {
		return intl.formatMessage({ id: "Plant" });
	}
	let limit = 15;
	for (let i = 0; i < limits.length; ++i) {
		if (limits[i].count < compressors.length) {
			limit = limits[i].limit;
		}
	}
	// wenn wir weniger als 6 kompressoren haben, lange version.
	if (compressors[cindex] && compressors[cindex].name && (compressors[cindex].name.length > 0)) {
		// wenn wir einen realen namen haben, verwenden bis 6 kompressoren oder 4 zeichen.
		if (compressors[cindex].name.length <= limit) {
			return (cindex + 1).toString() + ": " + compressors[cindex].name;
		}
		// sonst abkuerzen
		else {
			return (cindex + 1).toString() + ": " + compressors[cindex].name.substring(0, limit - 1) + ".";
		}
	}
	// sonst nur noch die nummer.
	return (cindex + 1).toString();
};

export const genComponentFormatterShort = (compressors, intl) => {
	return cindex => getComponentNameShort(cindex, compressors, intl);
};

export const compressorTicksShort = (data, compressors, intl) => {
	if (!data || !data.length) {
		return [""];
	}
	const ticks = data.map(d => getComponentNameShort(d.cindex, compressors, intl));
	return ticks;
};

export const getComponentNameLong = (cindex, compressors, intl) => {
	// die station!
	if (cindex < 0) {
		return intl.formatMessage({ id: "Plant" })
	}
	// wenn wir weniger als 6 kompressoren haben, lange version.
	if (compressors[cindex] && compressors[cindex].name && (compressors[cindex].name.length > 0)) {
		return compressors[cindex].name;
	}
	return intl.formatMessage({ id: "Compressor" }) + " " + (cindex + 1).toString();
};

export const genComponentFormatterLong = (compressors, intl) => {
	return cindex => getComponentNameLong(cindex, compressors, intl);
};

export const compressorTicksLong = (data, compressors, intl) => {
	if (!data || !data.length) {
		return [""];
	}
	const ticks = data.map(d => getComponentNameLong(d.cindex, compressors, intl));
	return ticks;
};